















import { useAdBnanner } from '@/hooks/use-ad-banner';
import { useCouponTaskDialog } from '@/hooks/use-coupon-task-dialog';
import WphkBanner from '@tencent/wphk-components-banner';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'AdBanner',
  components: {
    WphkBanner,
  },
  setup() {
    const { bannerList } = useAdBnanner();
    const { showDialogByBanner: showCouponTaskDialog } = useCouponTaskDialog();
    return {
      bannerList,
      onClick: (item) => {
        if (!item?.extraData?.eventType) return;
        const { couponId, taskId, eventType } = item.extraData;
        showCouponTaskDialog(taskId || couponId, eventType);
      },
    };
  },
});
